import React from "react";

const LogoAndCompName = () => {
    return (
        <div className="logo-outer">
            <a href="/">
                <img src="/img/logo_58x59_2.png" alt="logo" />
                <span>ShillGuard</span>
            </a>
        </div>
    )
}

export default LogoAndCompName;